// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthLogoutRouteImport } from './routes/_auth/logout'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as DashboardUsersRouteRouteImport } from './routes/_dashboard/users/route'
import { Route as DashboardUserLabelsRouteRouteImport } from './routes/_dashboard/user-labels/route'
import { Route as DashboardSettingsRouteRouteImport } from './routes/_dashboard/settings/route'
import { Route as DashboardSbcManagementRouteRouteImport } from './routes/_dashboard/sbc-management/route'
import { Route as DashboardQueuesRouteRouteImport } from './routes/_dashboard/queues/route'
import { Route as DashboardQueueGroupsRouteRouteImport } from './routes/_dashboard/queue-groups/route'
import { Route as DashboardOrganisationsRouteRouteImport } from './routes/_dashboard/organisations/route'
import { Route as DashboardLicensesManagementRouteRouteImport } from './routes/_dashboard/licenses-management/route'
import { Route as DashboardIvrRouteRouteImport } from './routes/_dashboard/ivr/route'
import { Route as DashboardGatewaysRouteRouteImport } from './routes/_dashboard/gateways/route'
import { Route as DashboardDivergencesRouteRouteImport } from './routes/_dashboard/divergences/route'
import { Route as DashboardClientManagementRouteRouteImport } from './routes/_dashboard/client-management/route'
import { Route as DashboardCallscreeningRouteRouteImport } from './routes/_dashboard/callscreening/route'
import { Route as DashboardBusinessDirectoryRouteRouteImport } from './routes/_dashboard/business-directory/route'
import { Route as DashboardAdministratorsRouteRouteImport } from './routes/_dashboard/administrators/route'
import { Route as DashboardQueuesNewQueueRouteImport } from './routes/_dashboard/queues/new-queue'
import { Route as DashboardQueuesQueueIdRouteRouteImport } from './routes/_dashboard/queues/$queueId/route'
import { Route as DashboardQueueGroupsNewGroupRouteImport } from './routes/_dashboard/queue-groups/new-group'
import { Route as DashboardQueueGroupsQueueGroupIdRouteRouteImport } from './routes/_dashboard/queue-groups/$queueGroupId/route'
import { Route as DashboardOrganisationsNewOrgRouteImport } from './routes/_dashboard/organisations/new-org'
import { Route as DashboardOrganisationsOrgIdRouteRouteImport } from './routes/_dashboard/organisations/$orgId/route'
import { Route as DashboardIvrNewIvrRouteImport } from './routes/_dashboard/ivr/new-ivr'
import { Route as DashboardIvrIvrIdRouteRouteImport } from './routes/_dashboard/ivr/$ivrId/route'
import { Route as DashboardCallscreeningSystemRouteImport } from './routes/_dashboard/callscreening/system'
import { Route as DashboardBusinessDirectoryTypesRouteRouteImport } from './routes/_dashboard/business-directory/types/route'
import { Route as DashboardBusinessDirectoryCategoriesRouteRouteImport } from './routes/_dashboard/business-directory/categories/route'
import { Route as DashboardBusinessDirectoryBusinessesRouteRouteImport } from './routes/_dashboard/business-directory/businesses/route'
import { Route as DashboardAdministratorsProfilesRouteRouteImport } from './routes/_dashboard/administrators/profiles/route'
import { Route as DashboardAdministratorsAccountsRouteRouteImport } from './routes/_dashboard/administrators/accounts/route'
import { Route as DashboardQueuesQueueIdSettingsRouteImport } from './routes/_dashboard/queues/$queueId/settings'
import { Route as DashboardQueuesQueueIdEditRouteImport } from './routes/_dashboard/queues/$queueId/edit'
import { Route as DashboardQueuesQueueIdCallScreeningRouteImport } from './routes/_dashboard/queues/$queueId/call-screening'
import { Route as DashboardQueuesQueueIdAgentsRouteImport } from './routes/_dashboard/queues/$queueId/agents'
import { Route as DashboardQueueGroupsQueueGroupIdQueuesRouteImport } from './routes/_dashboard/queue-groups/$queueGroupId/queues'
import { Route as DashboardQueueGroupsQueueGroupIdEditRouteImport } from './routes/_dashboard/queue-groups/$queueGroupId/edit'
import { Route as DashboardQueueGroupsQueueGroupIdAgentsRouteImport } from './routes/_dashboard/queue-groups/$queueGroupId/agents'
import { Route as DashboardOrganisationsOrgIdRenameRouteImport } from './routes/_dashboard/organisations/$orgId/rename'
import { Route as DashboardOrganisationsOrgIdPredefinedTextsRouteImport } from './routes/_dashboard/organisations/$orgId/predefined-texts'
import { Route as DashboardOrganisationsOrgIdEmailsRouteImport } from './routes/_dashboard/organisations/$orgId/emails'
import { Route as DashboardOrganisationsOrgIdUsersRouteRouteImport } from './routes/_dashboard/organisations/$orgId/users/route'
import { Route as DashboardOrganisationsOrgIdUserLabelsRouteRouteImport } from './routes/_dashboard/organisations/$orgId/user-labels/route'
import { Route as DashboardOrganisationsOrgIdSettingsRouteRouteImport } from './routes/_dashboard/organisations/$orgId/settings/route'
import { Route as DashboardOrganisationsOrgIdContactListRouteRouteImport } from './routes/_dashboard/organisations/$orgId/contact-list/route'
import { Route as DashboardOrganisationsOrgIdCallScreeningRouteRouteImport } from './routes/_dashboard/organisations/$orgId/call-screening/route'
import { Route as DashboardIvrIvrIdIndexRouteImport } from './routes/_dashboard/ivr/$ivrId/index'
import { Route as DashboardCallscreeningQueuesQueueIdRouteImport } from './routes/_dashboard/callscreening/queues/$queueId'
import { Route as DashboardCallscreeningOrganisationsOrgIdRouteImport } from './routes/_dashboard/callscreening/organisations/$orgId'
import { Route as DashboardBusinessDirectoryBusinessesOrganisationsRouteRouteImport } from './routes/_dashboard/business-directory/businesses/organisations/route'

const DashboardRouteRoute = DashboardRouteRouteImport.update({
            id: '/_dashboard',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthLogoutRoute = AuthLogoutRouteImport.update({
            id: '/_auth/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/_auth/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const DashboardUsersRouteRoute = DashboardUsersRouteRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => DashboardRouteRoute
          })
const DashboardUserLabelsRouteRoute = DashboardUserLabelsRouteRouteImport.update({
            id: '/user-labels',path: '/user-labels',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsRouteRoute = DashboardSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSbcManagementRouteRoute = DashboardSbcManagementRouteRouteImport.update({
            id: '/sbc-management',path: '/sbc-management',getParentRoute: () => DashboardRouteRoute
          })
const DashboardQueuesRouteRoute = DashboardQueuesRouteRouteImport.update({
            id: '/queues',path: '/queues',getParentRoute: () => DashboardRouteRoute
          })
const DashboardQueueGroupsRouteRoute = DashboardQueueGroupsRouteRouteImport.update({
            id: '/queue-groups',path: '/queue-groups',getParentRoute: () => DashboardRouteRoute
          })
const DashboardOrganisationsRouteRoute = DashboardOrganisationsRouteRouteImport.update({
            id: '/organisations',path: '/organisations',getParentRoute: () => DashboardRouteRoute
          })
const DashboardLicensesManagementRouteRoute = DashboardLicensesManagementRouteRouteImport.update({
            id: '/licenses-management',path: '/licenses-management',getParentRoute: () => DashboardRouteRoute
          })
const DashboardIvrRouteRoute = DashboardIvrRouteRouteImport.update({
            id: '/ivr',path: '/ivr',getParentRoute: () => DashboardRouteRoute
          })
const DashboardGatewaysRouteRoute = DashboardGatewaysRouteRouteImport.update({
            id: '/gateways',path: '/gateways',getParentRoute: () => DashboardRouteRoute
          })
const DashboardDivergencesRouteRoute = DashboardDivergencesRouteRouteImport.update({
            id: '/divergences',path: '/divergences',getParentRoute: () => DashboardRouteRoute
          })
const DashboardClientManagementRouteRoute = DashboardClientManagementRouteRouteImport.update({
            id: '/client-management',path: '/client-management',getParentRoute: () => DashboardRouteRoute
          })
const DashboardCallscreeningRouteRoute = DashboardCallscreeningRouteRouteImport.update({
            id: '/callscreening',path: '/callscreening',getParentRoute: () => DashboardRouteRoute
          })
const DashboardBusinessDirectoryRouteRoute = DashboardBusinessDirectoryRouteRouteImport.update({
            id: '/business-directory',path: '/business-directory',getParentRoute: () => DashboardRouteRoute
          })
const DashboardAdministratorsRouteRoute = DashboardAdministratorsRouteRouteImport.update({
            id: '/administrators',path: '/administrators',getParentRoute: () => DashboardRouteRoute
          })
const DashboardQueuesNewQueueRoute = DashboardQueuesNewQueueRouteImport.update({
            id: '/new-queue',path: '/new-queue',getParentRoute: () => DashboardQueuesRouteRoute
          })
const DashboardQueuesQueueIdRouteRoute = DashboardQueuesQueueIdRouteRouteImport.update({
            id: '/$queueId',path: '/$queueId',getParentRoute: () => DashboardQueuesRouteRoute
          })
const DashboardQueueGroupsNewGroupRoute = DashboardQueueGroupsNewGroupRouteImport.update({
            id: '/new-group',path: '/new-group',getParentRoute: () => DashboardQueueGroupsRouteRoute
          })
const DashboardQueueGroupsQueueGroupIdRouteRoute = DashboardQueueGroupsQueueGroupIdRouteRouteImport.update({
            id: '/$queueGroupId',path: '/$queueGroupId',getParentRoute: () => DashboardQueueGroupsRouteRoute
          })
const DashboardOrganisationsNewOrgRoute = DashboardOrganisationsNewOrgRouteImport.update({
            id: '/new-org',path: '/new-org',getParentRoute: () => DashboardOrganisationsRouteRoute
          })
const DashboardOrganisationsOrgIdRouteRoute = DashboardOrganisationsOrgIdRouteRouteImport.update({
            id: '/$orgId',path: '/$orgId',getParentRoute: () => DashboardOrganisationsRouteRoute
          })
const DashboardIvrNewIvrRoute = DashboardIvrNewIvrRouteImport.update({
            id: '/new-ivr',path: '/new-ivr',getParentRoute: () => DashboardIvrRouteRoute
          })
const DashboardIvrIvrIdRouteRoute = DashboardIvrIvrIdRouteRouteImport.update({
            id: '/$ivrId',path: '/$ivrId',getParentRoute: () => DashboardIvrRouteRoute
          })
const DashboardCallscreeningSystemRoute = DashboardCallscreeningSystemRouteImport.update({
            id: '/system',path: '/system',getParentRoute: () => DashboardCallscreeningRouteRoute
          })
const DashboardBusinessDirectoryTypesRouteRoute = DashboardBusinessDirectoryTypesRouteRouteImport.update({
            id: '/types',path: '/types',getParentRoute: () => DashboardBusinessDirectoryRouteRoute
          })
const DashboardBusinessDirectoryCategoriesRouteRoute = DashboardBusinessDirectoryCategoriesRouteRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => DashboardBusinessDirectoryRouteRoute
          })
const DashboardBusinessDirectoryBusinessesRouteRoute = DashboardBusinessDirectoryBusinessesRouteRouteImport.update({
            id: '/businesses',path: '/businesses',getParentRoute: () => DashboardBusinessDirectoryRouteRoute
          })
const DashboardAdministratorsProfilesRouteRoute = DashboardAdministratorsProfilesRouteRouteImport.update({
            id: '/profiles',path: '/profiles',getParentRoute: () => DashboardAdministratorsRouteRoute
          })
const DashboardAdministratorsAccountsRouteRoute = DashboardAdministratorsAccountsRouteRouteImport.update({
            id: '/accounts',path: '/accounts',getParentRoute: () => DashboardAdministratorsRouteRoute
          })
const DashboardQueuesQueueIdSettingsRoute = DashboardQueuesQueueIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardQueuesQueueIdRouteRoute
          })
const DashboardQueuesQueueIdEditRoute = DashboardQueuesQueueIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => DashboardQueuesQueueIdRouteRoute
          })
const DashboardQueuesQueueIdCallScreeningRoute = DashboardQueuesQueueIdCallScreeningRouteImport.update({
            id: '/call-screening',path: '/call-screening',getParentRoute: () => DashboardQueuesQueueIdRouteRoute
          })
const DashboardQueuesQueueIdAgentsRoute = DashboardQueuesQueueIdAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => DashboardQueuesQueueIdRouteRoute
          })
const DashboardQueueGroupsQueueGroupIdQueuesRoute = DashboardQueueGroupsQueueGroupIdQueuesRouteImport.update({
            id: '/queues',path: '/queues',getParentRoute: () => DashboardQueueGroupsQueueGroupIdRouteRoute
          })
const DashboardQueueGroupsQueueGroupIdEditRoute = DashboardQueueGroupsQueueGroupIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => DashboardQueueGroupsQueueGroupIdRouteRoute
          })
const DashboardQueueGroupsQueueGroupIdAgentsRoute = DashboardQueueGroupsQueueGroupIdAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => DashboardQueueGroupsQueueGroupIdRouteRoute
          })
const DashboardOrganisationsOrgIdRenameRoute = DashboardOrganisationsOrgIdRenameRouteImport.update({
            id: '/rename',path: '/rename',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdPredefinedTextsRoute = DashboardOrganisationsOrgIdPredefinedTextsRouteImport.update({
            id: '/predefined-texts',path: '/predefined-texts',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdEmailsRoute = DashboardOrganisationsOrgIdEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdUsersRouteRoute = DashboardOrganisationsOrgIdUsersRouteRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdUserLabelsRouteRoute = DashboardOrganisationsOrgIdUserLabelsRouteRouteImport.update({
            id: '/user-labels',path: '/user-labels',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdSettingsRouteRoute = DashboardOrganisationsOrgIdSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdContactListRouteRoute = DashboardOrganisationsOrgIdContactListRouteRouteImport.update({
            id: '/contact-list',path: '/contact-list',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdCallScreeningRouteRoute = DashboardOrganisationsOrgIdCallScreeningRouteRouteImport.update({
            id: '/call-screening',path: '/call-screening',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardIvrIvrIdIndexRoute = DashboardIvrIvrIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardIvrIvrIdRouteRoute
          })
const DashboardCallscreeningQueuesQueueIdRoute = DashboardCallscreeningQueuesQueueIdRouteImport.update({
            id: '/queues/$queueId',path: '/queues/$queueId',getParentRoute: () => DashboardCallscreeningRouteRoute
          })
const DashboardCallscreeningOrganisationsOrgIdRoute = DashboardCallscreeningOrganisationsOrgIdRouteImport.update({
            id: '/organisations/$orgId',path: '/organisations/$orgId',getParentRoute: () => DashboardCallscreeningRouteRoute
          })
const DashboardBusinessDirectoryBusinessesOrganisationsRouteRoute = DashboardBusinessDirectoryBusinessesOrganisationsRouteRouteImport.update({
            id: '/organisations',path: '/organisations',getParentRoute: () => DashboardBusinessDirectoryBusinessesRouteRoute
          })





const DashboardAdministratorsRouteRouteChildren = {
  DashboardAdministratorsAccountsRouteRoute: DashboardAdministratorsAccountsRouteRoute,DashboardAdministratorsProfilesRouteRoute: DashboardAdministratorsProfilesRouteRoute
}

const DashboardAdministratorsRouteRouteWithChildren = DashboardAdministratorsRouteRoute._addFileChildren(DashboardAdministratorsRouteRouteChildren)




const DashboardBusinessDirectoryBusinessesRouteRouteChildren = {
  DashboardBusinessDirectoryBusinessesOrganisationsRouteRoute: DashboardBusinessDirectoryBusinessesOrganisationsRouteRoute
}

const DashboardBusinessDirectoryBusinessesRouteRouteWithChildren = DashboardBusinessDirectoryBusinessesRouteRoute._addFileChildren(DashboardBusinessDirectoryBusinessesRouteRouteChildren)



const DashboardBusinessDirectoryRouteRouteChildren = {
  DashboardBusinessDirectoryBusinessesRouteRoute: DashboardBusinessDirectoryBusinessesRouteRouteWithChildren,DashboardBusinessDirectoryCategoriesRouteRoute: DashboardBusinessDirectoryCategoriesRouteRoute,DashboardBusinessDirectoryTypesRouteRoute: DashboardBusinessDirectoryTypesRouteRoute
}

const DashboardBusinessDirectoryRouteRouteWithChildren = DashboardBusinessDirectoryRouteRoute._addFileChildren(DashboardBusinessDirectoryRouteRouteChildren)




const DashboardCallscreeningRouteRouteChildren = {
  DashboardCallscreeningSystemRoute: DashboardCallscreeningSystemRoute,DashboardCallscreeningOrganisationsOrgIdRoute: DashboardCallscreeningOrganisationsOrgIdRoute,DashboardCallscreeningQueuesQueueIdRoute: DashboardCallscreeningQueuesQueueIdRoute
}

const DashboardCallscreeningRouteRouteWithChildren = DashboardCallscreeningRouteRoute._addFileChildren(DashboardCallscreeningRouteRouteChildren)




const DashboardIvrIvrIdRouteRouteChildren = {
  DashboardIvrIvrIdIndexRoute: DashboardIvrIvrIdIndexRoute
}

const DashboardIvrIvrIdRouteRouteWithChildren = DashboardIvrIvrIdRouteRoute._addFileChildren(DashboardIvrIvrIdRouteRouteChildren)



const DashboardIvrRouteRouteChildren = {
  DashboardIvrIvrIdRouteRoute: DashboardIvrIvrIdRouteRouteWithChildren,DashboardIvrNewIvrRoute: DashboardIvrNewIvrRoute
}

const DashboardIvrRouteRouteWithChildren = DashboardIvrRouteRoute._addFileChildren(DashboardIvrRouteRouteChildren)




const DashboardOrganisationsOrgIdRouteRouteChildren = {
  DashboardOrganisationsOrgIdCallScreeningRouteRoute: DashboardOrganisationsOrgIdCallScreeningRouteRoute,DashboardOrganisationsOrgIdContactListRouteRoute: DashboardOrganisationsOrgIdContactListRouteRoute,DashboardOrganisationsOrgIdSettingsRouteRoute: DashboardOrganisationsOrgIdSettingsRouteRoute,DashboardOrganisationsOrgIdUserLabelsRouteRoute: DashboardOrganisationsOrgIdUserLabelsRouteRoute,DashboardOrganisationsOrgIdUsersRouteRoute: DashboardOrganisationsOrgIdUsersRouteRoute,DashboardOrganisationsOrgIdEmailsRoute: DashboardOrganisationsOrgIdEmailsRoute,DashboardOrganisationsOrgIdPredefinedTextsRoute: DashboardOrganisationsOrgIdPredefinedTextsRoute,DashboardOrganisationsOrgIdRenameRoute: DashboardOrganisationsOrgIdRenameRoute
}

const DashboardOrganisationsOrgIdRouteRouteWithChildren = DashboardOrganisationsOrgIdRouteRoute._addFileChildren(DashboardOrganisationsOrgIdRouteRouteChildren)



const DashboardOrganisationsRouteRouteChildren = {
  DashboardOrganisationsOrgIdRouteRoute: DashboardOrganisationsOrgIdRouteRouteWithChildren,DashboardOrganisationsNewOrgRoute: DashboardOrganisationsNewOrgRoute
}

const DashboardOrganisationsRouteRouteWithChildren = DashboardOrganisationsRouteRoute._addFileChildren(DashboardOrganisationsRouteRouteChildren)




const DashboardQueueGroupsQueueGroupIdRouteRouteChildren = {
  DashboardQueueGroupsQueueGroupIdAgentsRoute: DashboardQueueGroupsQueueGroupIdAgentsRoute,DashboardQueueGroupsQueueGroupIdEditRoute: DashboardQueueGroupsQueueGroupIdEditRoute,DashboardQueueGroupsQueueGroupIdQueuesRoute: DashboardQueueGroupsQueueGroupIdQueuesRoute
}

const DashboardQueueGroupsQueueGroupIdRouteRouteWithChildren = DashboardQueueGroupsQueueGroupIdRouteRoute._addFileChildren(DashboardQueueGroupsQueueGroupIdRouteRouteChildren)



const DashboardQueueGroupsRouteRouteChildren = {
  DashboardQueueGroupsQueueGroupIdRouteRoute: DashboardQueueGroupsQueueGroupIdRouteRouteWithChildren,DashboardQueueGroupsNewGroupRoute: DashboardQueueGroupsNewGroupRoute
}

const DashboardQueueGroupsRouteRouteWithChildren = DashboardQueueGroupsRouteRoute._addFileChildren(DashboardQueueGroupsRouteRouteChildren)




const DashboardQueuesQueueIdRouteRouteChildren = {
  DashboardQueuesQueueIdAgentsRoute: DashboardQueuesQueueIdAgentsRoute,DashboardQueuesQueueIdCallScreeningRoute: DashboardQueuesQueueIdCallScreeningRoute,DashboardQueuesQueueIdEditRoute: DashboardQueuesQueueIdEditRoute,DashboardQueuesQueueIdSettingsRoute: DashboardQueuesQueueIdSettingsRoute
}

const DashboardQueuesQueueIdRouteRouteWithChildren = DashboardQueuesQueueIdRouteRoute._addFileChildren(DashboardQueuesQueueIdRouteRouteChildren)



const DashboardQueuesRouteRouteChildren = {
  DashboardQueuesQueueIdRouteRoute: DashboardQueuesQueueIdRouteRouteWithChildren,DashboardQueuesNewQueueRoute: DashboardQueuesNewQueueRoute
}

const DashboardQueuesRouteRouteWithChildren = DashboardQueuesRouteRoute._addFileChildren(DashboardQueuesRouteRouteChildren)



const DashboardRouteRouteChildren = {
  DashboardAdministratorsRouteRoute: DashboardAdministratorsRouteRouteWithChildren,DashboardBusinessDirectoryRouteRoute: DashboardBusinessDirectoryRouteRouteWithChildren,DashboardCallscreeningRouteRoute: DashboardCallscreeningRouteRouteWithChildren,DashboardClientManagementRouteRoute: DashboardClientManagementRouteRoute,DashboardDivergencesRouteRoute: DashboardDivergencesRouteRoute,DashboardGatewaysRouteRoute: DashboardGatewaysRouteRoute,DashboardIvrRouteRoute: DashboardIvrRouteRouteWithChildren,DashboardLicensesManagementRouteRoute: DashboardLicensesManagementRouteRoute,DashboardOrganisationsRouteRoute: DashboardOrganisationsRouteRouteWithChildren,DashboardQueueGroupsRouteRoute: DashboardQueueGroupsRouteRouteWithChildren,DashboardQueuesRouteRoute: DashboardQueuesRouteRouteWithChildren,DashboardSbcManagementRouteRoute: DashboardSbcManagementRouteRoute,DashboardSettingsRouteRoute: DashboardSettingsRouteRoute,DashboardUserLabelsRouteRoute: DashboardUserLabelsRouteRoute,DashboardUsersRouteRoute: DashboardUsersRouteRoute
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(DashboardRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DashboardRouteRoute: DashboardRouteRouteWithChildren,AuthLoginRoute: AuthLoginRoute,AuthLogoutRoute: AuthLogoutRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)